// extracted by mini-css-extract-plugin
module.exports = {"sider":"styles_sider__24bI7","siderChildren":"styles_siderChildren__1UjIi","logo":"styles_logo__3n3GO"};